import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { ApplicableFor, PatientPaymentMode, PaymentFlowType } from 'src/app/interfaces/payment-enums';
import { AppointmentRequestModel } from 'src/app/shared/models/request/appointment-request';
import { SalesOrderService } from '../services/salesorder.service';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { PaymentInformationModel } from 'src/app/interfaces/payment-information';
import { PaymentService } from 'src/app/shared/services/payment.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-pay-book-appointment',
  templateUrl: './pay-book-appointment.component.html',
  styleUrls: ['./pay-book-appointment.component.sass'],
  providers: [DialogService],
  standalone: false
})
export class PayBookAppointmentComponent extends BaseComponent implements OnInit, OnDestroy {
  @Output() closePayBookAppointment = new EventEmitter();
  @Output() patientAppointmentSummaryEmit: EventEmitter<number> = new EventEmitter();
  @Input() appointmentRequest: AppointmentRequestModel;
  @Input() salesOrderId: number;
  @Input() paymentData: PaymentInformationModel;

  flowType: PaymentFlowType = PaymentFlowType.PayAndSave;
  applicableFor = ApplicableFor.Patient;
  paymentStepName = 'Pay & Book Appointment';
  totalSteps = 4;
  private unsubscriber = new Subject<boolean>();

  constructor(
    private router: Router,
    messageService: MessageService,
    private salesOrderService: SalesOrderService,
    private webStorageService: WebStorageService,
    private paymentService: PaymentService
  ) {
    super(messageService);
  }

  ngOnInit() {
    this.paymentStepName = this.webStorageService.getPaymentStepName();
    const patientBookingTypeId = this.webStorageService.getPatientBookingTypeId();
    if (patientBookingTypeId == 'R' || patientBookingTypeId == 'SG') {
      this.totalSteps = 3;
    }
    this.setFlowType();

    this.paymentService.paymentCompletedPatient$.pipe(takeUntil(this.unsubscriber)).subscribe((paymentResponse) => {
      if (paymentResponse && paymentResponse.isSuccess) {
        this.salesOrderService.getSalesOrderDetails(this.salesOrderId.toString()).subscribe((res) => {
          const salesOrderData = res.responseModel;
          const appointmentConfirmation = this.webStorageService.getAppointmentConfirmation();
          appointmentConfirmation.schAppointmentId = salesOrderData.schAppointmentId ?? 0;
          this.webStorageService.storeAppointmentId(salesOrderData.schAppointmentId ?? 0);
          this.webStorageService.storeAppointmentConfirmation(appointmentConfirmation);
            this.router.navigate(['/patient/appointment-confirmation']);
        });
      }
    });
  }

  private setFlowType() {
    const mode = this.paymentData.patientPaymentMode;
    if (mode === PatientPaymentMode.COLLECT_PAYMENT) {
      this.flowType = PaymentFlowType.PayOnly;
    } else if (mode === PatientPaymentMode.COLLECT_AND_SAVE_CARD) {
      this.flowType = PaymentFlowType.PayAndSave;
    } else if (mode === PatientPaymentMode.SAVE_CARD) {
      this.flowType = PaymentFlowType.SaveOnly;
    }

    this.webStorageService.setPaymentStepName(this.paymentStepName);
  }

  onBack() {
    const paymentSetup = this.webStorageService.getPaymentSetup();
    if (paymentSetup) {
      this.paymentService.clearPaymentSetup(paymentSetup).subscribe(() => {
        this.webStorageService.deletePaymentSetup();
      });
    }

    const patientBookingTypeId = this.webStorageService.getPatientBookingTypeId();
    if (patientBookingTypeId == 'R' || patientBookingTypeId == 'SG') {
      this.patientAppointmentSummaryEmit.emit(2);
    } else {
      this.patientAppointmentSummaryEmit.emit(3);
    }
  }

  ngOnDestroy() {
    if (this.unsubscriber) {
      this.unsubscriber.next();
      this.unsubscriber.complete();
    }
  }
}
